import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import React, {useContext, useState, useMemo} from 'react';
import {DatePicker} from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import {Settings, Update} from '@mui/icons-material';
import ZeiterfassungDashboardContext from '../../../../../Contexts/ZeiterfassungDashboardContext/ZeiterfassungDashboardContext';
import WorkingDataOverviewTable from './WorkingDataOverviewTable';
import ZeiterfassungDashboardNoteContextProvider from '../../../../../Contexts/ZeiterfassungDashboardContext/ZeiterfassungDashboardNoteContextProvider';
import WorkingDataSetBearbeiter from './WorkingDataSetBearbeiter';
import FilterDepartment from './FilterDepartment';
import FilterUser from './FilterUser';
import FilterBauvorhaben from './FilterBauvorhaben';
import FilterReset from './FilterReset';
import ExportWorkingDataExcel from './ExportWorkingDataExcel';
import ExportWorkingDataPdf from './ExportWorkingDataPdf';
import { useTranslation } from 'react-i18next';
export default function WorkingDataOverview() {
  const {
    selectedDateStart,
    setSelectedDateStart,
    selectedDateEnde,
    setSelectedDateEnde,
    handle_Upadate_Arbeitszeiten_alle_MA,
    filteredData,
    isLoading,
  } = useContext(ZeiterfassungDashboardContext);

  const [open, setOpen] = useState(false);
  const {t} = useTranslation();
  const filterContent = useMemo(
    () => (
      <Box sx={{p: 2, pt: 0}}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 2,
          }}>
          {/* Date selection */}
          <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'space-between', gap: 1}}>
            <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1, me: 2}}>
              <DatePicker
                value={dayjs(selectedDateStart)}
                onChange={(value) => {
                  if (value != null) {
                    setSelectedDateStart(value.toDate());
                  }
                }}
              />
              <Typography variant='body2' sx={{mx: 1, color: 'text.secondary'}}>
                bis
              </Typography>
              <DatePicker
                value={dayjs(selectedDateEnde)}
                onChange={(value) => {
                  if (value != null) {
                    setSelectedDateEnde(value.toDate());
                  }
                }}
              />{' '}
              <Box
                sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1, ml: 3}}>
                <FilterDepartment />
                <FilterUser />
                <FilterBauvorhaben />
              </Box>
            </Box>
          </Box>

          {/* Filter components */}

          {/* Actions Group - Update button and FilterReset */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              ml: 'auto',
              gap: 1,
            }}>
            <FilterReset />
            <Tooltip title='Daten aktualisieren'>
              <span>
                <IconButton
                  onClick={handle_Upadate_Arbeitszeiten_alle_MA}
                  color='primary'
                  sx={{
                    backgroundColor: 'rgba(25, 118, 210, 0.08)',
                    padding: '10px',
                    '&:hover': {
                      backgroundColor: 'rgba(25, 118, 210, 0.15)',
                    },
                  }}
                  disabled={isLoading}>
                  {isLoading ? <CircularProgress size={24} /> : <Update />}
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    ),
    [selectedDateStart, selectedDateEnde, isLoading, handle_Upadate_Arbeitszeiten_alle_MA]
  );
 
  return (
    <Card >
      <CardHeader
        title={<Typography variant='h4'>{t('overview_timesheets')}</Typography>}
        action={
          <Box sx={{display: 'flex', gap: 2}}>
            <ExportWorkingDataExcel />
            <ExportWorkingDataPdf />
            <Tooltip title='Einstellungen für die Ansicht'>
              <IconButton
                onClick={() => setOpen(true)}
                sx={{
                  bgcolor: 'rgba(0, 0, 0, 0.04)',
                  '&:hover': {
                    bgcolor: 'rgba(0, 0, 0, 0.08)',
                  },
                }}>
                <Settings />
              </IconButton>
            </Tooltip>
          </Box>
        }
        sx={{p: 2}}
      />
        {filterContent}
        <ZeiterfassungDashboardNoteContextProvider>
          <WorkingDataOverviewTable
            timeRange={{start: selectedDateStart, end: selectedDateEnde}}
            notes={(filteredData.notes || []).map((note) => ({
              ...note,
              id: note.id ?? 0,
            }))}
            user_zeiterfassung={filteredData.user_zeiterfassung || []}
            data={filteredData.arbeitszeiten || []}
            isAdmin={true}
          />
        </ZeiterfassungDashboardNoteContextProvider>
        <WorkingDataSetBearbeiter open={open} setOpen={setOpen} />

    </Card>
  );
}
